import ContentLayout from '@/components/layout/ContentLayout';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { useState } from 'react';
import { toast } from 'sonner';
import { importQuestionCandidates, importAbTasks } from '@/services/generatedAPIs';

export default function ExpertAdminPage() {
  const [isLoading, setIsLoading] = useState(false);

  const handleImportQuestionCandidates = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    try {
      setIsLoading(true);
      const response = await importQuestionCandidates({ file });

      if (response.code === 200) {
        toast.success(`成功导入 ${response.data} 条候选题目`);
      } else {
        toast.error('导入失败：' + response.message);
      }
    } catch (error) {
      toast.error('导入失败');
    } finally {
      setIsLoading(false);
      e.target.value = '';
    }
  };

  const handleImportAbTasks = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    try {
      setIsLoading(true);
      const response = await importAbTasks({ file });

      if (response.code === 200) {
        toast.success(`成功导入 ${response.data} 条 AB 任务`);
      } else {
        toast.error('导入失败：' + response.message);
      }
    } catch (error) {
      toast.error('导入失败');
    } finally {
      setIsLoading(false);
      e.target.value = '';
    }
  };

  return (
    <ContentLayout title="数据导入">
      <div className="flex flex-col items-center justify-center min-h-[60vh] gap-6">
        <h2 className="text-2xl font-bold">专家标注数据导入</h2>

        <div className="flex flex-col gap-4 w-80">
          <div>
            <Input
              id="question-file"
              type="file"
              accept=".csv"
              className="hidden"
              onChange={handleImportQuestionCandidates}
            />
            <Button
              variant="outline"
              disabled={isLoading}
              onClick={() => document.getElementById('question-file')?.click()}
              className="w-full"
            >
              导入候选题目 CSV
            </Button>
          </div>

          <div>
            <Input
              id="task-file"
              type="file"
              accept=".csv"
              className="hidden"
              onChange={handleImportAbTasks}
            />
            <Button
              variant="outline"
              disabled={isLoading}
              onClick={() => document.getElementById('task-file')?.click()}
              className="w-full"
            >
              导入 AB 任务 CSV
            </Button>
          </div>
        </div>
      </div>
    </ContentLayout>
  );
}
